import * as Sentry from '@sentry/react'

type ErrorCategory = 'expected' | 'unexpected'

function getSentry(): typeof Sentry | null {
  try {
    return Sentry
  } catch {
    return null
  }
}

export const logger = {
  debug: (message: string, ...data: unknown[]) => {
    if (import.meta.env.DEV) {
      console.debug(`[DBG] ${message}`, ...data)
    }
  },

  info: (message: string, ...data: unknown[]) => {
    if (import.meta.env.DEV) {
      console.info(`[INF] ${message}`, ...data)
    } else {
      getSentry()?.addBreadcrumb({ category: 'info', message, data })
    }
  },

  warn: (message: string, ...data: unknown[]) => {
    console.warn(`[WRN] ${message}`, ...data)
    getSentry()?.addBreadcrumb({ category: 'warn', message, data })
  },

  error: (message: string, error: unknown, category: ErrorCategory = 'unexpected') => {
    console.error(`[ERR] [${category}] ${message}`, error)
    if (import.meta.env.PROD && category === 'unexpected') {
      getSentry()?.captureException(error, {
        extra: { message, category },
      })
    }
  },
}

export type { ErrorCategory }
